import {isEvent} from 'common-data-handling';
import React from 'react';
import {useI18n} from '../../../../data/hooks/i18nHooks';
import CurrentUser from '../CurrentUser';

/**
 * Shows the "This event will be added to" description
 * It shows different labels for events and communities
 *
 * @param {Object} props - the props object containing event and user
 * @param {Object} props.event - the event object
 * @param {Object} props.user - the user object
 * @return {JSX.Element} the JSX element to be rendered
 */
function AddEventWithCodeToAccountDescription(props) {
    const {event, user} = props,
        i18n = useI18n();

    if (!user) return null; // user is required to show this info
    if (!event) return null; // event is required to be added

    let label = '';
    if (isEvent(event)) {
        label = i18n['label.event.add-to-account'];
    } else {
        // isCommunity(event)
        label = i18n['label.community.add-to-account'];
    }

    return (
        <div style={{padding: '2em 0em', color: '#999'}}>
            <p>
                <span>{label}</span>:
            </p>
            <CurrentUser />
        </div>
    );
}

export default AddEventWithCodeToAccountDescription;
